<!-- ScorePHQ9.vue -->
<template>
  <v-card>
    <v-card-title  class="text-h6 font-weight-bold mb-2">
      {{ $t('scales.gq6.title') }}
    </v-card-title>
    <v-card-text class="px-6 pb-6">
      <div class="mb-8">

        <!--Scores-->
        <div class="mb-3">
          <div class="text-subtitle-1 font-weight-medium mb-2">
            {{ $t('scales.gq6.score') }}: {{ score.total.raw.value }} / {{ score.total.raw.max }}
          </div>
          <v-progress-linear
            :model-value="(score.total.raw.value/score.total.raw.max) * 100"
            :color="getColor(score.total.raw.color)"
            height="12"
            rounded
          ></v-progress-linear>
        </div>

        <!--Interpretations-->
        <v-alert
          :color="getColor(score.total.raw.color)"
          variant="tonal"
          class="mt-3"
        >
          <template v-slot:prepend>
            <v-icon>mdi-brain</v-icon>
          </template>
          <div>
            <strong>{{ $t('scales.gq6.interpretation') }}:</strong>
            <v-list>
              <v-list-item
                v-for="(item, index) in interpretations"
                :key="index"
                :title="typeof item === 'string' ? item : item.title"
                class="text-wrap"
              ></v-list-item>
            </v-list>
          </div>
        </v-alert>
      </div>

      <!--Individual answers-->
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ $t('scales.gq6.answers') }}
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-list lines="one">
              <v-list-item
                v-for="item, idx in scale.items"
                :key="idx"
                :title="(idx+1) + '. ' + item.text"
                :subtitle="answerText(scale.answers[idx])"
              ></v-list-item>
            </v-list>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>


    </v-card-text>
  </v-card>
</template>

<script>
import {getColor} from '@/utils/scales.js';

export default {
  name: 'ScoreGQ6',
  data() {
    return {
      scale_id: 'gq6'
    }
  },
  props: {
    scale: {
      type: Object,
      required: true
    },
  },
  
  methods: {
    getColor,

    /**Get the answer text for an item*/
    answerText(answerValue){
      console.info(typeof answerValue)
      return this.scale.options.find(opt => opt.score == parseInt(answerValue)).name
    },
  },

  computed: {
    score() {
      return this.scale.scores;
    },
    interpretations() {
      return this.scale.interpretations;
    },

    severityColor() {
      const colors = {
        'Minimal': 'green',
        'Mild': 'yellow',
        'Moderate': 'orange',
        'Moderately Severe': 'deep-orange',
        'Severe': 'red'
      };
      return colors['Minimal'];
    },

    // interpretationText() {
    //   // Detailed clinical interpretation based on score
    //   const texts = {
    //     'Minimal': 'Minimal or no depression symptoms.',
    //     'Mild': 'Mild depression. Watchful waiting, repeat PHQ-9 at follow-up.',
    //     // ... etc
    //   };
    //   return texts[this.interpretation];
    // }
  }
}
</script>

<style scoped>
.v-list-item :deep(.v-list-item-title) {
  white-space: normal !important;
  overflow-wrap: break-word !important;
}
</style>